/*
--------------------------------------
RC-49-PLP-list-products
--------------------------------------
*
*/

$( document ).ready(function() {
  $('.products__thumb__mobile ul').on('click', 'li', function() { // PLP Mobile thumbnail active class script.
    $('.products__thumb__mobile ul li.active').removeClass('active');
    $(this).addClass('active');
  });

  $(".products__grids").on("click",function() { // PLP add grid class to parent div based on clicking grid option.
    $('.ProductListWrapper').addClass('product-grid').removeClass('product-list');
  });
  
  $(".products__list").on("click",function() { // PLP add list class to parent div based on clicking list option.
    $('.ProductListWrapper').removeClass('product-grid').addClass('product-list');
  });

  if ($(window).width() < 1008) {
    $('.in-stock-filter').insertBefore('#collection-sort-popover .Popover__ValueList'); // RC-64 In stock filter script for tablet & mobile
  }
});

